function Page404() {
  return <div className="center">Page Not Found</div>
}

export default Page404
